import React from "react";
import { Balance } from "../models/balance";
import { BackButton } from "../../views/common-forms/components";
import BalanceItem from "./BalanceItem";

interface BalanceListProps {
    balanceItems: Balance[];
    cancelClick: () => void;
}

const BalanceList: React.SFC<BalanceListProps> = props => {
    return (
        <div>
            {props.balanceItems.map((balance, index) => (
                <div key={index} className="balanceItem-card">
                    <BalanceItem key={index} balanceItem={balance} />
                </div>
            )
            )}
            <div className="balance-footer">
                <BackButton onClick={props.cancelClick} />
            </div>
        </div>
    );
};
export default BalanceList;